import { LanguageName } from '@components/AppBar/app-bar-state';
import { LanguageCodes } from '@customTypes';

export const getLanguageCode = (lang: LanguageName) => {
  switch (lang) {
    case LanguageName.German:
      return LanguageCodes.German;
    default:
      return LanguageCodes.English;
  }
};
